import { render, staticRenderFns } from "./component.vue?vue&type=template&id=24139fc6&scoped=true&lang=html&"
import script from "./component.vue?vue&type=script&lang=js&"
export * from "./component.vue?vue&type=script&lang=js&"
import style0 from "./component.vue?vue&type=style&index=0&id=24139fc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24139fc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\progect\\guowai\\ex_express_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24139fc6')) {
      api.createRecord('24139fc6', component.options)
    } else {
      api.reload('24139fc6', component.options)
    }
    module.hot.accept("./component.vue?vue&type=template&id=24139fc6&scoped=true&lang=html&", function () {
      api.rerender('24139fc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/d2-echart/component.vue"
export default component.exports